<template lang="pug">
.report-info
  v-card.white--text(color="indigo")
    v-card-title(primary-title)
      div
        p.subheading.font-weight-bold 親愛的鄉親，歡迎來到會費繳納登錄系統，請依照指示將款項轉帳或匯款至下列帳戶後，填寫登錄表單，以利完成繳納作業。謝謝您對同鄉會的支持！
    v-card-text
      div.report-info__account.text-xs-center.pa-2
        .headline 台中銀行 桃園分行
        .headline 129-28-0009555
    v-card-text
      v-btn(
        color="warning"
        block
        large
        @click="$emit('next')") 我已匯款，填寫匯款資料表單
    v-card-text
      v-card
        v-list(dark)
          v-list-tile
            v-list-tile-title.subheading.text-xs-center 會員身份費用表
          v-list-group(
            v-for="info in infoTable"
            :key="info.title"
            v-model="info.active")
            template(v-slot:activator)
              v-list-tile(color="info")
                v-list-tile-content
                  v-list-tile-title(dark) {{ info.title }}
            v-list-tile(
              v-for="(item, index) in info.items"
              :key="index")
              v-list-tile-content
                v-list-tile-title {{ item }}
</template>
<script>
const infoTable = [
  { title: "新會員", items: ["入會費 1,000", "常年會費 1,000"], active: true },
  { title: "一般會員", items: ["常年會費 1,000"], active: false },
  { title: "永久會員", items: ["一次性會費 12,000"], active: false },
  { title: "顧問", items: ["職務捐 至少5,000"], active: false },
  { title: "舊顧問", items: ["職務捐 至少3,000"], active: false },
  {
    title: "理監事",
    items: ["常年會費 1,000", "職務捐 3,000", "輪值捐 2,000"],
    active: false
  },
  {
    title: "常務理監事",
    items: ["常年會費 1,000", "職務捐 6,000", "輪值捐 2,000"],
    active: false
  },
  {
    title: "副理事長",
    items: ["常年會費 1,000", "職務捐 20,000", "輪值捐 2,000"],
    active: false
  },
  { title: "榮譽理事長", items: ["常年會費 1,000"], active: false },
  { title: "輔導理事長", items: ["常年會費 1,000"], active: false },
  { title: "理事長", items: ["職務捐 100,000"], active: false }
];

export default {
  name: "ReportInfo",
  data() {
    return {
      infoTable
    };
  }
};
</script>

<style lang="styl">
.report-info
  &__account
    border 1.5px solid white
    border-radius 10px
</style>
